import { Box, LinearProgress } from '@mui/material'
import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

import { Line } from 'react-chartjs-2'
import _ from 'lodash'
import { useGetSalesStats } from '../../api/sales'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

const AmountChart = ({ query }) => {
  const { data: salesData, isLoading } = useGetSalesStats(_.pickBy(query, _.identity))

  const { year, htgCompany } = query

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Sales',
      },
    },
  }

  const data = []

  const months = _.keys(salesData?.[year])

  for (let month of months) {
    const days = _.keys(salesData[year][month])
    for (let day of days) {
      data.push({
        x: `${year}-${month}-${_.padStart(day, 2, 0)}`,
        y: _.chain(salesData[year][month][day]).sumBy('amount').round(2).value(),
      })
    }
  }

  return (
    <Box>
      <Line
        options={options}
        data={{
          datasets: [
            {
              label: htgCompany,
              data: data,
              borderColor: 'rgb(255, 99, 132)',
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
          ],
        }}
      />
      <br />
      {isLoading && <LinearProgress />}
    </Box>
  )
}

export default AmountChart
